// extracted by mini-css-extract-plugin
export var cardHeader = "_sw-0";
export var reorderHandle = "_sw-3";
export var titleArea = "_sw-1";
export var titleAreaWithHandle = "_sw-2";